const basePath = '/archeidos';

export class ArcheidosPath {
  static index() {
    return basePath;
  }
}
